<template>
  <div class="receipt-boxes">
    <div class="receipt-box" v-for="(receipt, index) in _contentData" :key="index" :data-index="index" :id="'cocktail-' + index">
       <img :src="receipt.images[1].url" alt="" class="checkers-receipt  custom_pattern" v-if="receipt.images[1] && receipt.images[1].url">
      <picture v-else>
   
        <source media="(max-width:1439px)" srcset="@/assets/img/yellowcheckersm3.jpg">
        <source media="(max-width:1919px)" srcset="@/assets/img/yellowcheckersm2.jpg">
       <img src="@/assets/img/yellowcheckers2.jpg" class="checkers-receipt" alt="">
       </picture>
      
       <!-- <div v-html="receipt.stickers[0]" v-if="receipt.stickers" class="receipt-sticker"></div>
       <div v-html="receipt.stickers[1]" v-if="receipt.stickers" class="receipt-sticker"></div> -->
        <div class="container-landing">
      <div class="left-col">
        <img :src="receipt.images[0].url" alt="" class="receipt-img" />

      </div>
      <div class="right-col">
        <h2 class="regular f-55 receipt-ttl">{{ receipt.title }}</h2>
        <div class="description" v-html="receipt.description"></div>
        <div class="ingredients-box">
          <!-- <img
            :src="require('@/assets/img/' + receipt.logo)"
            alt=""
            class="receipt-logo"
          /> -->

          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="1.062" height="220.797" viewBox="0 0 1.062 220.797">
              <path id="Path_3786" data-name="Path 3786" d="M17.344,7.157c63.51-.416,127.831.037,191.64-.228,16.174-.067,25.6-.9,3.82-.81-63.826.266-128.011-.188-191.64.228C5.355,6.451-4.351,7.3,17.344,7.157Z" transform="translate(-6.112 225.547) rotate(-90)" fill="#fff"/>
            </svg>
          </div>
          <div class="bg-icon">
            <img src="@/assets/img/ingredintsbg.png" />
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="100 100" preserveAspectRatio="none">
              <path id="Path_1867" data-name="Path 1867" d="M5054.762-19467.781c-7.681,26.949-6.377,95.492-8.6,139.041s-4.512,162.057,6.76,181.391,131.878.555,172.908,0,154.351,3.633,162.022-21.816,7.531-65.762,4.7-111.5c-2.832-45.754-.61-159.018-16.589-182.186s-126.23-14.916-173.078-18.9S5062.443-19494.709,5054.762-19467.781Z" transform="translate(-5044.33 19486.434)" fill="#044b30"/>
            </svg> -->
          </div>
          <div class="receipt-logo" v-html="receipt.svg"></div>
          <h2 class="f-21 bold-italic static-ttl">{{$fn.tr('ინგრედიენტები')}}</h2>
          <div class="row-rapper">
          <div
            class="row"
            v-for="(ingredient, index) in receipt.newIngredients.newArr"
            :key="index + 'ING'"
          >
            <div class="svg" v-html="ingredient.svg"></div>
            <div class="text-box">
              <span class="ttl f-16 light-italic" v-if="$route.name === 'en'">{{ ingredient.title_en }}</span>
              <span class="ttl f-16 light-italic" v-if="$route.name === 'ge'">{{ ingredient.title_ge }}</span>
              <span class="subttl f-13 light-italic" v-if="$route.name === 'en'">{{ingredient.sub_title_en}}</span>
              <span class="subttl f-13 light-italic" v-if="$route.name === 'ge'">{{ingredient.sub_title_ge}}</span>
            </div>
          </div>
          </div>
        </div>
        <div class="note">
          <svg id="fi-sr-info" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g id="Group_1872" data-name="Group 1872">
    <path id="Path_3847" data-name="Path 3847" d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM10,4.167a1.25,1.25,0,1,1-1.25,1.25A1.25,1.25,0,0,1,10,4.167ZM9.167,8.333H10A1.667,1.667,0,0,1,11.667,10v5A.833.833,0,0,1,10,15V10H9.167a.833.833,0,0,1,0-1.667Z" fill="#101820"/>
  </g>
</svg>
  <span class="f-14 light-italic">{{$fn.tr('ინგრედიენტები მოცემულია 240მლ მოცულობის ჭიქაზე')}}</span>
        </div>
      
        <svg class="r-line" xmlns="http://www.w3.org/2000/svg" width="350" height="1" viewBox="0 0 350 1">
  <path id="Path_3806" data-name="Path 3806" d="M24.714,7.1C125.387,6.7,227.348,7.132,328.5,6.882c25.639-.063,40.584-.849,6.056-.763-101.174.251-202.919-.178-303.782.215C5.709,6.431-9.676,7.231,24.714,7.1Z" transform="translate(-4.75 -6.112)" fill="#3a5aa7" opacity="0.3"/>
</svg>

<OrderService />



      </div>
      </div>

    </div>
  </div>
</template>

<script>
import OrderService from "@/components/OrderService";
export default {
  props: ['contentData'],
  components: {OrderService},
  data() {
    return {
    
    };
  },
  watch: {

  },
  computed: {
    cocktailTarget(){
      return this.$store.state.main.cocktailTarget;
    },
    _contentData(){
         let _l = [..._.get(this.contentData, 'data.list')]; 
         for (let i = 0; i < _l.length; i++) {
            let n = []
           let newIngredients = {
             newArr: n,
           }
          
           _l[i].newIngredients = newIngredients;
           
           let attr = _l[i].allAttributes;

           let _attr = this.$store.state.main.indx.attributes.ingredients;
           for (let k = 0; k < _attr.length; k++) {
             for (let j = 0; j < attr.length; j++) {
               if(attr[j] == _attr[k].id){
                n.push(_attr[k])

               }
               
             }
             
           }
         }
         return _l;
      },
  },
  mounted(){
    var storenum = this.$store.state.main.cocktailTarget
    console.log('store index', this.$store.state.main.cocktailTarget )
       document.querySelectorAll('.receipt-boxes .receipt-box').forEach(function(item) {
      if (item.getAttribute('data-index') == storenum) {
        console.log(item)
      }
    })
  }
};
</script>

<style lang="scss" >
.bg-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // z-index: 2;
  svg, img {
    position: absolute;
    top: 0;
    left: 0;
    
    width: 100%;
    height: 100%;
  }
}
.icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 74px;
    left: 85px;
    width: 10px;
    height: calc(100% - 91px);
    z-index: 3;
  svg {
    width: 100%;
    height: 100%;
  }
}
.description p, .description span, .description strong, .description h1, .description h2, .description h3, .description h4, .description h5, .description h6{
  font-family: "FiraGO-Italic";
}
// .receipt-ttl{
//   font-family: "Jujuna-Regular";
// }
.description p, .receipt-boxes .receipt-box .right-col .receipt-ttl, .receipt-boxes .receipt-box .right-col .ingredients-box .static-ttl,
.receipt-boxes .receipt-box .right-col .ingredients-box .row .text-box .ttl, .receipt-boxes .receipt-box .right-col .ingredients-box .row .text-box .subttl,
.receipt-boxes .receipt-box .right-col .ingredients-box .row .svg svg, .receipt-boxes .receipt-box .right-col .note span, .receipt-boxes .receipt-box .right-col .note svg,
.text-wrapper svg, .text-wrapper span{
  will-change: transform;
}
</style>
